export default __webpack_public_path__ + "static/media/Snd_CY.7330f083.mp3";